module.exports = __webpack_public_path__ + "static/media/keertivarma.689f5c65.png";